export { editDocumentRoute } from './route'
